import Applications from "./ApplicationsContainer";

export default Applications;
